import SocialLogos from "../SocialLogos/SocialLogos";
import {
  CopyrightContainer,
  CopyrightText,
  FooterBottom,
  LandingContainer,
} from "./BottomBar.styles";

type BottomBarProps = {
  data?: { inOrgName: string; orgCopyrightYear: string };
};

export const BottomBar = ({ data }: BottomBarProps) => {
  const IN_ORG_NAME = data?.inOrgName || "MAKEMYTRIP PVT. LTD.";
  const ORG_COPYRIGHT_YEAR = data?.orgCopyrightYear || "© 2026";
  return (
    <FooterBottom>
      <LandingContainer>
        <SocialLogos />
        <CopyrightContainer>
          <CopyrightText>
            {`${ORG_COPYRIGHT_YEAR} ${IN_ORG_NAME}`}
          </CopyrightText>
        </CopyrightContainer>
      </LandingContainer>
    </FooterBottom>
  );
};

export default BottomBar;
